// extracted by mini-css-extract-plugin
export default {"create":"styles_create__9YAoP","row":"styles_row__hYZ7u","col":"styles_col__PnKdu","flexRight":"styles_flexRight__JfnNT"};